import React from 'react';
import { Route, Switch } from 'react-router-dom';
import {
    AdminUsers,
    AdminCharities,
    Error404,
    AdminUserDetails,
    AdminCharityDetails,
} from '../domains';

const AdminRoutes = () => (
    <Switch>
        <Route exact path="/admin/charities" component={AdminCharities} />
        <Route
            path="/admin/charities/:accountId"
            component={AdminCharityDetails}
        />
        <Route exact path="/admin/users" component={AdminUsers} />
        <Route path="/admin/users/:accountId" component={AdminUserDetails} />
        <Route component={Error404} />
    </Switch>
);

export default AdminRoutes;
